import { render, staticRenderFns } from "./newRecord.vue?vue&type=template&id=f5eba870&"
import script from "./newRecord.vue?vue&type=script&lang=js&"
export * from "./newRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports